export default "__VITE_ASSET__db94c3d7__"